import React from "react";
import { useParams, Navigate } from "react-router-dom";
// City-scoped URL: /city/:cityName -> reuses Schools listing with city filter preloaded
export default function CityPage() {
  const { cityName } = useParams();
  return <Navigate to={`/schools?city=${encodeURIComponent(cityName)}`} replace />;
}
